<div class="offer-view-card">
  <app-offer-image [offer]="offer" imageClass="offer-image"></app-offer-image>

  <div class="offer-content">

    <div class="offer-details">
      <div class="offer-title">{{ offer?.title }}</div>
    </div>
  </div>
</div>